import { useEffect } from "react";

type CopyTrackElement = Document | HTMLElement | null;

export const useTrackCopyText = (
    trackingCallback: (selection: string) => void,
    element: CopyTrackElement = document,
) => {
    useEffect(() => {
        const handleCopy = () => {
            const selectedText = window.getSelection()?.toString();
            if (selectedText) {
                trackingCallback(selectedText);
            }
        };

        element?.addEventListener("copy", handleCopy);
        return () => {
            element?.removeEventListener("copy", handleCopy);
        };
    }, [element, trackingCallback]);
};
